<div class="collect-container">
  <div class="page-header">
    <h1>Collect a Payment</h1>
    <p class="subtitle">Charge a customer a one-off amount</p>
  </div>

  <div class="collect-content">
    <div class="collect-section">
      <div class="error-banner" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="success-banner" *ngIf="successMessage">{{ successMessage }}</div>

      <div class="form-group">
        <label for="custId">Customer user id</label>
        <input type="number" id="custId" name="custId"
               [(ngModel)]="customerUserId" (change)="loadCustomer()" placeholder="e.g. 42">
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="amt">Amount (USD)</label>
          <input type="number" id="amt" name="amt" min="0" step="0.01" [(ngModel)]="amount">
        </div>
        <div class="form-group">
          <label for="desc">Description</label>
          <input type="text" id="desc" name="desc" [(ngModel)]="description"
                 placeholder="e.g. Deposit for kitchen remodel">
        </div>
      </div>

      <div class="form-group" *ngIf="customerUserId">
        <label for="card">Card</label>
        <select id="card" name="card" [(ngModel)]="selectedCardId" (change)="onCardChoiceChange()">
          <option *ngFor="let c of savedCards" [value]="c.id">
            {{ c.brand | titlecase }} •••• {{ c.lastFourDigits }}{{ c.isDefault ? ' (default)' : '' }}
          </option>
          <option value="">Enter a new card…</option>
        </select>
      </div>

      <div class="form-group" *ngIf="customerUserId && !selectedCardId">
        <label>Card details</label>
        <div #cardEl class="card-element"></div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn btn-primary" (click)="charge()" [disabled]="processing">
          {{ processing ? 'Processing…' : 'Charge' }}
        </button>
      </div>
    </div>

    <div class="collect-section" *ngIf="history.length">
      <h2>Payment history</h2>
      <table class="history-table">
        <tr><th>Date</th><th>Amount</th><th>Status</th><th>Description</th></tr>
        <tr *ngFor="let p of history">
          <td>{{ p.createdAt | date:'short' }}</td>
          <td>{{ p.amount | currency:(p.currency || 'usd').toUpperCase() }}</td>
          <td>{{ p.status }}</td>
          <td>{{ p.description }}</td>
        </tr>
      </table>
    </div>
  </div>
</div>
